import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FlairrSummaryComponent } from './flairr-summary.component';
import { Shell } from '@app/shell/shell.service';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  Shell.publicRoutes([
    { path: 'flairr-summary', component: FlairrSummaryComponent, data: { title: 'Flairr Summary' } },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class FlairrSummaryRoutingModule {}
